<template>
  <router-view/>
</template>

<script>
export default {
  name: "AdminReports"
}
</script>
